export default __webpack_public_path__ + "static/media/gallery-arrow-right.ebfb2bcb.svg";